// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__16g5R","file":"styles_file__fX8Zs"};